const form = document.forms.school_switcher;

if (form) {
  const field = document.getElementById('school_switch_id');
  field.addEventListener('change', () => form.submit());
}
